import React, { useState } from "react";
import Slider from "react-slick";
import { ImageGalleryViewModel } from "./ImageGalleryViewModel.csharp";
import { ImageGalleryArrow } from "./ImageGalleryArrow";

export const ImageGallery: React.FC<ImageGalleryViewModel> = ({ images }) => {
  const [bigSlider, setBigSlider] = useState<any>(null);
  const [smallSlider, setSmallSlider] = useState<any>(null);

  return (
    <div className="mb-5">
      <Slider
        asNavFor={smallSlider}
        arrows={false}
        className={"slick-gallery mb-2 px-0"}
        lazyLoad={"progressive"}
        ref={(slider) => setBigSlider(slider)}
      >
        {images.map((img, i) => (
          <figure className="slick-slide-figure" key={"img_"+i}>
            <div className="slick-slide-image"><img className="mx-auto" src={img.url} alt={img.title} /></div>
            {img.title ? <figcaption className="slick-slide-figcaption">{img.title}</figcaption> : null}
          </figure>
        ))}
      </Slider>
      <div className="slick-slider-thumbs-container">
        <Slider
          asNavFor={bigSlider}
          ref={(slider) => setSmallSlider(slider)}
          className={"px-0"}
          slidesToShow={5}
          swipeToSlide={true}
          focusOnSelect={true}
          arrows={true}
          lazyLoad={"progressive"}
          infinite={images.length > 5}
          prevArrow={<ImageGalleryArrow prev />}
          nextArrow={<ImageGalleryArrow />}
        >
          {images.map((img, i) => (
            <img src={img.url} alt={img.title} className="" key={"thmb_"+i} />
          ))}
        </Slider>
      </div>
    </div>
  );
};
